(function () {
    'use strict';
    $(document).ready(function () {

        // Smooth scroll to
        $('a[href^="#"]').on('click', function (e) {
            e.preventDefault();

            const href = $(this).attr('href');
            if (href) {
                $("html, body").animate({
                    scrollTop: $(href).offset().top - 40
                }, 1000);
            }
        });

        $('.scroll-animation a').on('click', function (e) {
            e.stopPropagation();
        });

        $('.scroll-to-top').click(function () {
            $('html, body').animate({ scrollTop: 0 }, 'slow');
        });

        $(window).on('scroll load', function () {
            if ($(document).scrollTop() >= $(window).height()) {
                $('.scroll-to-top').addClass('active');
            } else {
                $('.scroll-to-top').removeClass('active');
            }
        });


        // Object fit IE11 polyfill
        objectFitImages();
    });
}(jQuery));
